// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

.record-modal_modal-content_JQLtL {
  width: 600px;
}

.record-modal_body_wqW6X {
  background: var(--ui-modal-background);
  padding: 1.5rem 2.25rem;
}

.record-modal_visualization-container_zBELg {
  display: flex;
  justify-content: space-around;
}

.record-modal_meter-container_e3yUw,
.record-modal_waveform-container_iTvrr {
  background: var(--ui-primary);
  border: 1px solid var(--ui-black-transparent);
  border-radius: 5px;
  padding: 3px;
  /* Force these to be on their own render layer because they update often */
  transform: translateZ(0);
}

.record-modal_meter-container_e3yUw {
  margin-right: 5px;
  height: 180px;
}

.record-modal_waveform-container_iTvrr {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 180px;
  position: relative;
}

.record-modal_help-text_aEAGo {
  margin: 10px auto 0;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  color: rgb(167, 170, 181);
  font-size: 0.95rem;
  font-weight: 500;
}

.record-modal_playing-text_OuRRK {
  color: var(--looks-secondary);
}

.record-modal_recording-text_qThZY {
  color: var(--red-primary);
}

.record-modal_main-button-row_llnJz {
  display: flex;
  justify-content: space-around;
  margin-top: 15px;
}

.record-modal_main-button-row_llnJz button {
  padding: 0.5rem 0.75rem;
  border-radius: 0.25rem;
  background: transparent;
  border: none;
}

.record-modal_main-button-row_llnJz button:disabled {
  opacity: 0.25;
}

.record-modal_main-button-row_llnJz button:active,
.record-modal_main-button-row_llnJz button:focus {
  outline: none;
}

.record-modal_button-row_pPZt9 {
  font-weight: bolder;
  text-align: right;
  display: flex;
  justify-content: space-between;
}

.record-modal_button-row_pPZt9 button {
  padding: 0.75rem 1rem;
  border-radius: 0.25rem;
  background: white;
  border: 1px solid var(--ui-black-transparent);
  font-weight: 600;
  font-size: 0.85rem;
  color: var(--looks-secondary);
}

.record-modal_button-row_pPZt9 button.record-modal_ok-button_zlC87 {
  background: var(--looks-secondary);
  border: var(--looks-secondary);
  color: white;
}

.record-modal_button-row_pPZt9 button + button {
  margin-left: 0.5rem;
}

.record-modal_main-button_Rsj0w {
  text-align: center;
}

/* Increase specificity to make sure this wins out over normalize.css */

svg.record-modal_record-button_MR0bC {
  overflow: visible;
}

.record-modal_record-button-circle_Euuf4 {
  fill: var(--red-primary);
  stroke: var(--red-tertiary);
}

.record-modal_record-button-circle-outline_RQ7EQ {
  fill: var(--red-primary);
  opacity: 0.2;
  transition: 0.1s;
}

[dir='rtl'] .record-modal_rerecord-button_jSt8a img {
  transform: scaleX(-1);
}
`, "",{"version":3,"sources":["webpack://./src/components/record-modal/record-modal.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;EACE,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;;EAEE,6BAA6B;EAC7B,6CAA6C;EAC7C,kBAAkB;EAClB,YAAY;EACZ,0EAA0E;EAC1E,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,2DAA2D;EAC3D,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,6CAA6C;EAC7C,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,uEAAuE;;AAEvE;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n.modal-content {\n  width: 600px;\n}\n\n.body {\n  background: var(--ui-modal-background);\n  padding: 1.5rem 2.25rem;\n}\n\n.visualization-container {\n  display: flex;\n  justify-content: space-around;\n}\n\n.meter-container,\n.waveform-container {\n  background: var(--ui-primary);\n  border: 1px solid var(--ui-black-transparent);\n  border-radius: 5px;\n  padding: 3px;\n  /* Force these to be on their own render layer because they update often */\n  transform: translateZ(0);\n}\n\n.meter-container {\n  margin-right: 5px;\n  height: 180px;\n}\n\n.waveform-container {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  width: 100%;\n  height: 180px;\n  position: relative;\n}\n\n.help-text {\n  margin: 10px auto 0;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  color: rgb(167, 170, 181);\n  font-size: 0.95rem;\n  font-weight: 500;\n}\n\n.playing-text {\n  color: var(--looks-secondary);\n}\n\n.recording-text {\n  color: var(--red-primary);\n}\n\n.main-button-row {\n  display: flex;\n  justify-content: space-around;\n  margin-top: 15px;\n}\n\n.main-button-row button {\n  padding: 0.5rem 0.75rem;\n  border-radius: 0.25rem;\n  background: transparent;\n  border: none;\n}\n\n.main-button-row button:disabled {\n  opacity: 0.25;\n}\n\n.main-button-row button:active,\n.main-button-row button:focus {\n  outline: none;\n}\n\n.button-row {\n  font-weight: bolder;\n  text-align: right;\n  display: flex;\n  justify-content: space-between;\n}\n\n.button-row button {\n  padding: 0.75rem 1rem;\n  border-radius: 0.25rem;\n  background: white;\n  border: 1px solid var(--ui-black-transparent);\n  font-weight: 600;\n  font-size: 0.85rem;\n  color: var(--looks-secondary);\n}\n\n.button-row button.ok-button {\n  background: var(--looks-secondary);\n  border: var(--looks-secondary);\n  color: white;\n}\n\n.button-row button + button {\n  margin-left: 0.5rem;\n}\n\n.main-button {\n  text-align: center;\n}\n\n/* Increase specificity to make sure this wins out over normalize.css */\n\nsvg.record-button {\n  overflow: visible;\n}\n\n.record-button-circle {\n  fill: var(--red-primary);\n  stroke: var(--red-tertiary);\n}\n\n.record-button-circle-outline {\n  fill: var(--red-primary);\n  opacity: 0.2;\n  transition: 0.1s;\n}\n\n[dir='rtl'] .rerecord-button img {\n  transform: scaleX(-1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-content": `record-modal_modal-content_JQLtL`,
	"modalContent": `record-modal_modal-content_JQLtL`,
	"body": `record-modal_body_wqW6X`,
	"visualization-container": `record-modal_visualization-container_zBELg`,
	"visualizationContainer": `record-modal_visualization-container_zBELg`,
	"meter-container": `record-modal_meter-container_e3yUw`,
	"meterContainer": `record-modal_meter-container_e3yUw`,
	"waveform-container": `record-modal_waveform-container_iTvrr`,
	"waveformContainer": `record-modal_waveform-container_iTvrr`,
	"help-text": `record-modal_help-text_aEAGo`,
	"helpText": `record-modal_help-text_aEAGo`,
	"playing-text": `record-modal_playing-text_OuRRK`,
	"playingText": `record-modal_playing-text_OuRRK`,
	"recording-text": `record-modal_recording-text_qThZY`,
	"recordingText": `record-modal_recording-text_qThZY`,
	"main-button-row": `record-modal_main-button-row_llnJz`,
	"mainButtonRow": `record-modal_main-button-row_llnJz`,
	"button-row": `record-modal_button-row_pPZt9`,
	"buttonRow": `record-modal_button-row_pPZt9`,
	"ok-button": `record-modal_ok-button_zlC87`,
	"okButton": `record-modal_ok-button_zlC87`,
	"main-button": `record-modal_main-button_Rsj0w`,
	"mainButton": `record-modal_main-button_Rsj0w`,
	"record-button": `record-modal_record-button_MR0bC`,
	"recordButton": `record-modal_record-button_MR0bC`,
	"record-button-circle": `record-modal_record-button-circle_Euuf4`,
	"recordButtonCircle": `record-modal_record-button-circle_Euuf4`,
	"record-button-circle-outline": `record-modal_record-button-circle-outline_RQ7EQ`,
	"recordButtonCircleOutline": `record-modal_record-button-circle-outline_RQ7EQ`,
	"rerecord-button": `record-modal_rerecord-button_jSt8a`,
	"rerecordButton": `record-modal_rerecord-button_jSt8a`
};
export default ___CSS_LOADER_EXPORT___;
